import { Link } from "react-router";
import { cn } from "@util/helpers";

type PromoteCNTranslationProps = {
  /** Optional className for the component */
  className?: string;
  /** Flag to know if translation is available for the article. */
  isTranslationAvailable?: boolean;
  /** Link to the chinese translation of the article. Must start with / */
  link: string;
};

/**
 * Promotes the chinese translation of an article.
 * https://www.figma.com/design/rR8akVWS3SksIyaOSqetu4/WEB-BAU-2025?node-id=16154-16723&t=XX7i49eHVpOxTDsV-4
 */
const PromoteCNTranslation = ({
  className,
  isTranslationAvailable = false,
  link,
}: PromoteCNTranslationProps): React.ReactElement => {
  if (!isTranslationAvailable) return <></>;
  if (!link.startsWith("/")) return <></>;

  return (
    <div data-testid="promote-cn-translation-component" className={className}>
      <Link
        to={`/zh-hans${link}?ref=article-sc`}
        className={cn(
          "underline-po font-notoSansSC text-lg font-medium leading-150 tracking-2 underline underline-offset-2"
        )}
        reloadDocument
      >
        阅读简体中文版 (beta)
      </Link>
    </div>
  );
};

export default PromoteCNTranslation;
